import { render, staticRenderFns } from "./IconEnvelope.vue?vue&type=template&id=294b2b34&"
import script from "./IconEnvelope.vue?vue&type=script&lang=ts&"
export * from "./IconEnvelope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports